import GlassCard from './GlassCard'
import ProgressBar from './ProgressBar'

export default function MetricCard({ icon: Icon, label, value, max, info, onUpgrade }) {
  const hasMax = typeof max === 'number' && max > 0
  const ratio = hasMax ? value / max : 0
  const percent = hasMax ? Math.min(100, ratio * 100) : 0

  const state = !hasMax
    ? 'normal'
    : ratio >= 1
      ? 'danger'
      : ratio >= 0.8
        ? 'warning'
        : 'normal'

  const showUpgrade = hasMax && ratio >= 0.8

  const valueText = (value ?? 0).toLocaleString('pt-br')
  const maxText = hasMax ? max.toLocaleString('pt-br') : '∞'

  return (
    <GlassCard className="p-5">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <div
            className="flex h-8 w-8 items-center justify-center rounded-xl border"
            style={{
              background: 'var(--dash-icon-bg)',
              borderColor: 'var(--dash-border)',
            }}
          >
            <Icon size={14} style={{ color: 'var(--dash-text-soft)' }} />
          </div>
          <div>
            <div
              className="text-xs font-medium"
              style={{ color: 'var(--dash-text-muted)' }}
            >
              {label}
            </div>
            {info && (
              <div
                className="mt-0.5 text-[10px]"
                style={{ color: 'var(--dash-text-faint)' }}
              >
                {info}
              </div>
            )}
          </div>
        </div>
        {showUpgrade && (
          <button
            type="button"
            onClick={onUpgrade}
            className="text-[11px] font-medium underline-offset-2 hover:underline"
            style={{ color: 'var(--dash-primary)' }}
          >
            Upgrade
          </button>
        )}
      </div>

      <div className="mt-4 flex items-baseline gap-1.5">
        <span
          className="text-3xl font-semibold tabular-nums tracking-tight"
          style={{ color: 'var(--dash-text)' }}
        >
          {valueText}
        </span>
        <span
          className="text-xs tabular-nums"
          style={{ color: 'var(--dash-text-faint)' }}
        >
          / {maxText}
        </span>
      </div>

      <div className="mt-4">
        <ProgressBar percent={percent} state={state} />
        {hasMax && (
          <div
            className="mt-2 flex items-center justify-between text-[10px]"
            style={{ color: 'var(--dash-text-faint)' }}
          >
            <span>{Math.round(percent)}% usado</span>
            {state === 'danger' && (
              <span style={{ color: 'var(--dash-danger)' }}>Limite atingido</span>
            )}
            {state === 'warning' && (
              <span style={{ color: 'var(--dash-warning)' }}>Próximo do limite</span>
            )}
          </div>
        )}
      </div>
    </GlassCard>
  )
}
